import { HoldingsService } from "../service/asyncBatchHoldingsService";
import * as validations from "../utils/validations";
import { HoldingExclude } from "../types/app.enums";

export class HoldingsFunctions {
  fnBurgissHoldingCalcTotalInvested(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null || beginDate != "") {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }

      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }
    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().burgissHoldingCalcTotalInvested(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcCostBasis(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }

      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }

    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }
    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcCostBasis(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcReturnOfCapital(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }

      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }

    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcReturnOfCapital(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcProceeds(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    if (beginDate != null) {
      beginDate = validations.isValidBeginDate(beginDate);
      if (beginDate === false) {
        return "#INVALIDPARAMETERS - Invalid Begin Date parameter";
      }

      const dateCmp: boolean = validations.dateCompare(beginDate, endDate);
      if (dateCmp == false) {
        return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
      }
    }

    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcProceeds(
      investId,
      endDate,
      baseorlocalcurrency,
      beginDate,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcValuation(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }
    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcValuation(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcValuationDate(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }
    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcValuationDate(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcDPI(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }
    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcDPI(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcRVPI(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }

    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }
    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcRVPI(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissHoldingCalcTVPI(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    excludeBalanceSheetItems?: any,
    excludeUndisclosedItems?: any,
    excludeUnknownEntities?: any,
    excludRealizationspriorclosingdt?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    rollForward = validations.validRFParam(rollForward);
    if (rollForward == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Roll Forward parameter";
    }
    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    excludeBalanceSheetItems = validations.holdingParamValidation(
      excludeBalanceSheetItems,
      HoldingExclude.ValuationDate
    );
    if (excludeBalanceSheetItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Balance Sheet Items parameter";
    }
    excludeUndisclosedItems = validations.holdingParamValidation(excludeUndisclosedItems, HoldingExclude.ValuationDate);
    if (excludeUndisclosedItems == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Undisclosed Items parameter";
    }
    excludeUnknownEntities = validations.holdingParamValidation(excludeUnknownEntities, HoldingExclude.ValuationDate);

    if (excludeUnknownEntities == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }
    excludRealizationspriorclosingdt = validations.holdingParamValidation(
      excludRealizationspriorclosingdt,
      HoldingExclude.ValuationDate
    );

    if (excludRealizationspriorclosingdt == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid Exclude Unkonown Entities parameter";
    }

    return new HoldingsService().BurgissHoldingCalcTVPI(
      investId,
      endDate,
      baseorlocalcurrency,
      rollForward,
      idType,
      selectionSetId,
      filter,
      excludeBalanceSheetItems,
      excludeUndisclosedItems,
      excludeUnknownEntities,
      excludRealizationspriorclosingdt,
      alternateCurrrency,
      uniqueCellId
    );
  }
}
